import { useState } from 'react';
import { Info, X } from 'lucide-react';

const HelpTooltip = ({ title, formula, explanation, example, notes }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {/* Icon trigger */}
      <button
        onClick={() => setIsOpen(true)}
        className="inline-flex items-center justify-center w-5 h-5 ml-1 text-gray-400 hover:text-primary transition-colors rounded-full hover:bg-primary/5"
        aria-label={`Aide pour ${title}`}
      >
        <Info className="w-4 h-4" />
      </button>

      {/* Modal */}
      {isOpen && (
        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:p-0">
            {/* Backdrop */}
            <div
              className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75"
              onClick={() => setIsOpen(false)}
            />

            {/* Modal panel */}
            <div className="relative inline-block w-full max-w-2xl p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-lg">
              {/* Header */}
              <div className="flex items-start justify-between mb-4">
                <div className="flex items-center">
                  <div className="flex items-center justify-center w-10 h-10 mr-3 bg-primary/10 rounded-full">
                    <Info className="w-6 h-6 text-primary" />
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900">{title}</h3>
                </div>
                <button
                  onClick={() => setIsOpen(false)}
                  className="text-gray-400 hover:text-gray-600 transition-colors"
                >
                  <X className="w-6 h-6" />
                </button>
              </div>

              {/* Content */}
              <div className="space-y-4">
                {/* Formula */}
                {formula && (
                  <div className="p-4 bg-primary/5 rounded-lg border border-primary/20">
                    <div className="text-sm font-medium text-primary-darker mb-2">📐 Formule</div>
                    <div className="font-mono text-sm text-primary-dark whitespace-pre-wrap">{formula}</div>
                  </div>
                )}

                {/* Explanation */}
                <div>
                  <div className="text-sm font-medium text-gray-700 mb-2">💡 Explication</div>
                  <p className="text-gray-600 leading-relaxed">{explanation}</p>
                </div>

                {/* Example */}
                {example && (
                  <div className="p-4 bg-green-50 rounded-lg border border-green-200">
                    <div className="text-sm font-medium text-green-900 mb-2">📊 Exemple</div>
                    <div className="text-sm text-green-800 whitespace-pre-wrap">{example}</div>
                  </div>
                )}

                {/* Notes */}
                {notes && notes.length > 0 && (
                  <div className="p-4 bg-yellow-50 rounded-lg border border-yellow-200">
                    <div className="text-sm font-medium text-yellow-900 mb-2">⚠️ Points importants</div>
                    <ul className="list-disc list-inside space-y-1">
                      {notes.map((note, index) => (
                        <li key={index} className="text-sm text-yellow-800">{note}</li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>

              {/* Footer */}
              <div className="mt-6 flex justify-end">
                <button
                  onClick={() => setIsOpen(false)}
                  className="px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary-dark transition-colors"
                >
                  Compris
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default HelpTooltip;
